<div class="container-fluid">
  <form [formGroup]="myFormPal" (ngSubmit)="onSubmit()">
    <div class="row paddingContainer">
      <ng-template mat-tab-label>
        {{ "cebe.generalData.palData.title" | translate }}
      </ng-template>
      <div class="col-md-6">
        <div>
          <input
            type="hidden"
            formControlName="cebeID"
            [value]="myFormPal.get('cebeID').value"
          />
          <input
            type="hidden"
            formControlName="id"
            [value]="myFormPal.get('id').value"
          />
          <div class="hidden">
            <mat-label class="checkBoxPanel paddingLabel"
              >{{ "cebe.generalData.palData.informationPal" | translate }}
            </mat-label>
            <mat-slide-toggle
              color="warn"
              formControlName="disponeInfo"
              [checked]="this.pal?.disponeInfo ?? true"
            >
            </mat-slide-toggle>
          </div>
        </div>
        <div class="dataBlock">
          <div class="profile-container">
            <img [src]="photo" class="img-responsive profile-image" alt="" />
            <div class="profile-content">
              <mat-form-field class="example-full-width">
                <mat-label>{{
                  "cebe.generalData.palData.manager" | translate
                }}</mat-label>
                <input
                  type="text"
                  [placeholder]="'shared.refineSearch' | translate"
                  aria-label="Número"
                  matInput
                  class="dataInput"
                  [formControl]="employeeControl"
                  [matAutocomplete]="autoPal"
                  #nombreInputPal
                />
                <cdk-virtual-scroll-viewport
                  class="autocomplete-test-viewport"
                  itemSize="50"
                  minBufferPx="500"
                  maxBufferPx="750"
                >
                  <mat-autocomplete
                    #autoPal="matAutocomplete"
                    [displayWith]="displayFn"
                    (optionSelected)="onOptionSelected($event)"
                  >
                    <mat-option
                      *cdkVirtualFor="let option of employeesfilter"
                      [value]="option"
                      class="autocomplete-item"
                    >
                      {{ option.nombre }}
                    </mat-option>
                  </mat-autocomplete>
                </cdk-virtual-scroll-viewport>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.palData.offerAdjudicated" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            [value]="0.0"
            class="dataInput"
            formControlName="ofertaAdjudica"
            step="0.01"
            twoDecimalNumber
          />
        </div>
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.palData.dateAdjudication" | translate
          }}</mat-label>
          <div class="datepicker-container">
            <input
              matInput
              [matDatepicker]="pickerAdjudication"
              formControlName="fechaAdjudica"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerAdjudication">
            </mat-datepicker-toggle>
            <mat-datepicker #pickerAdjudication></mat-datepicker>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkBlock">
          <mat-label class="checkBoxPanel paddingLabel"
            >{{ "cebe.generalData.palData.gis" | translate }}
            <mat-icon
              class="info"
              matSuffix
              [matTooltip]="
                this._translateService.instant(
                  'cebe.generalData.palData.gisToolTip'
                )
              "
              >info</mat-icon
            >
          </mat-label>
          <mat-slide-toggle
            [checked]="this.pal?.gis"
            color="warn"
            formControlName="gis"
          >
          </mat-slide-toggle>
        </div>
        <div class="inputBlock instSocialRisks">
          <mat-label>{{
            "cebe.generalData.palData.socialRisk" | translate
          }}</mat-label>
          <mat-select class="dataInput" formControlName="riesgoSocialID">
            <mat-option *ngFor="let item of socialRisks" [value]="item.id">
              {{
                "cebe.generalData.palData.socialRisks." + item.codigo
                  | translate
              }}
            </mat-option>
          </mat-select>
        </div>

        <div class="inputBlock assigned-budget-container instBudgetAssigned">
          <mat-label
            >{{ "cebe.generalData.palData.budgetAssigned" | translate }}
            <mat-icon
              class="info"
              matSuffix
              [matTooltip]="
                this._translateService.instant(
                  'cebe.generalData.palData.budgetToolTip'
                )
              "
              >info</mat-icon
            >
          </mat-label>
          <input
            matInput
            type="number"
            class="dataInput"
            formControlName="presupuestoAsignado"
            step="0.01"
            twoDecimalNumber
          />
        </div>
      </div>
    </div>
  </form>
</div>
